import React from 'react';
import { motion } from 'framer-motion';

const Privacy = () => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8"
        >
            <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden">
                <div className="bg-yellow-500 py-6 px-8">
                    <h1 className="text-3xl font-bold text-white">Politique de Confidentialité</h1>
                    <p className="text-yellow-100 mt-2">Dernière mise à jour : 26 novembre 2025</p>
                </div>

                <div className="p-8 space-y-8 text-gray-600 dark:text-gray-300">
                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">1. Introduction</h2>
                        <p>La protection de vos données personnelles est essentielle pour Tekhdem.com. La présente politique explique la collecte, l’utilisation et la protection de vos informations.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">2. Données Collectées</h2>
                        <ul className="list-disc ml-5 space-y-1">
                            <li><strong>Données personnelles :</strong> nom, prénom, email, téléphone, CV, expériences, diplômes.</li>
                            <li><strong>Données techniques :</strong> adresse IP, type de navigateur, pages consultées, durée de navigation.</li>
                            <li><strong>Cookies et technologies similaires :</strong> utilisés pour améliorer la navigation, analyser l’usage et personnaliser les contenus.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">3. Finalités</h2>
                        <p className="mb-2">Les données collectées sont utilisées pour :</p>
                        <ul className="list-disc ml-5 space-y-1">
                            <li>Fournir et gérer les services Tekhdem.com.</li>
                            <li>Permettre la mise en relation entre candidats et entreprises.</li>
                            <li>Améliorer et personnaliser l’expérience utilisateur.</li>
                            <li>Communiquer sur les services et offres pertinentes.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">4. Partage et Diffusion</h2>
                        <ul className="list-disc ml-5 space-y-1">
                            <li>Les données personnelles ne sont partagées qu’avec les entreprises inscrites sur le Site pour le recrutement.</li>
                            <li>Tekhdem.com ne vend ni ne loue vos données à des tiers.</li>
                            <li>Les autorités légales peuvent avoir accès aux données si requis par la loi.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">5. Sécurité</h2>
                        <p>Tekhdem.com met en œuvre des mesures techniques et organisationnelles pour protéger les données contre tout accès non autorisé, altération, perte ou divulgation.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">6. Conservation des Données</h2>
                        <p>Les données personnelles sont conservées tant que le compte utilisateur est actif ou conformément aux obligations légales.</p>
                        <p className="mt-2">En cas de suppression de compte, certaines données peuvent être archivées pour respecter les obligations légales.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">7. Droits des Utilisateurs</h2>
                        <p>Conformément à la loi algérienne, vous disposez des droits suivants :</p>
                        <ul className="list-disc ml-5 mt-2 space-y-1">
                            <li>Droit d’accès, de rectification et de suppression de vos données.</li>
                            <li>Droit d’opposition au traitement pour motifs légitimes.</li>
                        </ul>
                        <p className="mt-3">Pour exercer ces droits, contactez-nous à : <strong>contact@tekhdem.com</strong></p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">8. Cookies et Tracking</h2>
                        <p>Les cookies sont utilisés pour analyser le trafic, personnaliser les services et améliorer l’expérience.</p>
                        <p className="mt-2">Les utilisateurs peuvent désactiver les cookies via leur navigateur, mais certaines fonctionnalités peuvent être limitées.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">9. Modification de la Politique</h2>
                        <p>La politique peut être modifiée à tout moment. Les changements seront publiés sur le Site avec la date de mise à jour. L’usage continu du Site implique l’acceptation des modifications.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3">10. Contact</h2>
                        <p>Pour toute question concernant notre politique de confidentialité :</p>
                        <div className="mt-2 bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                            <p><strong>Email :</strong> contact@tekhdem.com</p>
                            <p><strong>Adresse :</strong> Alger, Algérie</p>
                        </div>
                    </section>

                    <div className="pt-8 text-center text-sm text-gray-500 border-t border-gray-200 dark:border-gray-700">
                        <p>© {new Date().getFullYear()} Tekhdem.com - Tous droits réservés.</p>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default Privacy;
